// hooks/useDashboardData.ts
import { useQuery } from "@tanstack/react-query";
import { settingService } from "@/api/settingService";

export const useFitnessCenter = (enabled = true) => {
  return useQuery({
    queryKey: ["fitnessCenter"], // single query key
    queryFn: settingService.fetchFitnessCenterInfo,
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled,
  });
};
